import lazyGettext from 'js-utils/lazy-gettext';

/* GDPR Modal */
export const GDPR_MODAL_HEADER = lazyGettext('Stay in the know');
export const GDPR_MODAL_DESCRIPTION = lazyGettext('Receive emails and notifications about this creator so you don\'t miss out.');
export const GDPR_ACCEPT_COPY = lazyGettext('OK');
export const GDPR_REJECT_COPY = lazyGettext('No thanks');
export const SAVE_ORGANIZER_FOLLOW_PREFERENCE_ERROR = lazyGettext('There was an issue saving your preference.');
